// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { TwingateNetworkSchema } from './TwingateNetworkSchema';

/////////////////////////////////////////
// TWINGATE NETWORK RELATION SCHEMA
/////////////////////////////////////////

export type TwingateNetworkRelations = {
  application: ApplicationWithRelations[];
};

export type TwingateNetworkWithRelations = z.infer<typeof TwingateNetworkSchema> & TwingateNetworkRelations

export const TwingateNetworkWithRelationsSchema: z.ZodType<TwingateNetworkWithRelations> = TwingateNetworkSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema).array(),
}))